export default __webpack_public_path__ + "static/media/Contribute.d0e2e696.png";